import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';

@Component({
    selector: 'ca-files-upload-progress',
    templateUrl: './files-upload-progress.component.html',
    styleUrls: ['./files-upload-progress.component.scss'],
})
export class FilesUploadProgressComponent {
    @Input() uploader: FileUploader;
    @Input() dynamicClasses: boolean = true;
    @Output() cancelFileUpload = new EventEmitter<FileItem>();
    @Output() progressChanged = new EventEmitter<void>();

    getQueueAreaCssClasses(): Object {
        return {
            'h-20': this.uploader?.isUploading && this.uploader?.queue.length === 1,
            'h-30': this.uploader?.isUploading && this.uploader?.queue.length >= 2,
        };
    }
}
